import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const LinkIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <g clipPath="url(#clip0_7533_30343)">
      <path
        d="M6.66669 8.66666C6.95299 9.04942 7.31826 9.36612 7.73772 9.59529C8.15718 9.82446 8.62103 9.96074 9.09779 9.99489C9.57455 10.029 10.0531 9.96024 10.5009 9.79318C10.9488 9.62613 11.3554 9.36471 11.6934 9.02666L13.6934 7.02666C14.3005 6.39799 14.6365 5.55598 14.6289 4.68199C14.6213 3.808 14.2708 2.97196 13.6527 2.35394C13.0347 1.73591 12.1987 1.38535 11.3247 1.37775C10.4507 1.37016 9.60869 1.70614 8.98002 2.31333L7.83335 3.45333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9.33334 7.33335C9.04704 6.9506 8.68177 6.6339 8.26231 6.40472C7.84285 6.17555 7.37901 6.03927 6.90224 6.00513C6.42548 5.97098 5.94695 6.03977 5.49911 6.20683C5.05127 6.37389 4.6446 6.6353 4.30668 6.97335L2.30668 8.97335C1.69948 9.60203 1.3635 10.444 1.3711 11.318C1.37869 12.192 1.72926 13.0281 2.34728 13.6461C2.96531 14.2641 3.80135 14.6147 4.67534 14.6223C5.54933 14.6299 6.39134 14.2939 7.02001 13.6867L8.16001 12.5467"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7533_30343">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
